import { ControlPageCardItem } from "../types/controlPageCardItem";
import { ControlPanelCategory } from "../types/ControlPanelCategory";
import { useGetSectionItems } from "./useGetSectionItems";
import { usePercentageRing } from "./usePercentageRing";
type ControlPanelSectionData = {
    sectionTitle: string;
    percentage: number;
    toggleItems: ControlPageCardItem[];
};

export const useControlPanelPageData = () => {
    const { getDnaSectionTitle, getDnaSectionItems, getBloodSectionTitle, getBloodSectionItems, getClinicalHistoryItems, getMedicalEquipeItems, getCheckUpItems, getHealthPlanItems, getMealPlanItems } = useGetSectionItems()
    const { getTotalDnaPercentage, getTotalBloodPercentage, getTotalClinicalHistoryPercentage, getTotaMedicalEquipePercentage } = usePercentageRing()
    const controlPanelData: Record<ControlPanelCategory, ControlPanelSectionData> = {
        [ControlPanelCategory.DNA_TEST]: {
            sectionTitle: getDnaSectionTitle(),
            percentage: getTotalDnaPercentage().percentage,
            toggleItems: getDnaSectionItems(),
        },
        [ControlPanelCategory.BLOOD_TEST]: {
            sectionTitle: getBloodSectionTitle(),
            percentage: getTotalBloodPercentage().percentage,
            toggleItems: getBloodSectionItems(),
        },
        [ControlPanelCategory.CLINICAL_HISTORY]: {
            sectionTitle: "Storia clinica",
            percentage: getTotalClinicalHistoryPercentage().percentage,
            toggleItems: getClinicalHistoryItems(),
        },
        [ControlPanelCategory.MEDICAL_EQUIPE]: {
            sectionTitle: "Medical equipe",
            percentage: getTotaMedicalEquipePercentage(),
            toggleItems: getMedicalEquipeItems(),
        },
        [ControlPanelCategory.MEAL_PLAN]: {
            sectionTitle: "Meal Plan",
            percentage: 0,
            toggleItems: getMealPlanItems(),
        },
        [ControlPanelCategory.HEALTH_PLAN]: {
            sectionTitle: "Health Plan",
            percentage: 0,
            toggleItems: getHealthPlanItems(),
        },
        [ControlPanelCategory.CHECK_UP]: {
            sectionTitle: "Check-up",
            percentage: 0,
            toggleItems: getCheckUpItems(),
        }
    };
    return { controlPanelData}
}